<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资讯管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ isEditMode ? '编辑资讯' : '新增资讯' }}</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>
      <el-form :model="form" :rules="formRules" ref="formRef" label-width="120px" style="width: 900px">
        <!-- 标题 -->
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入资讯标题"></el-input>
        </el-form-item>

        <!-- 简介描述 -->
        <el-form-item label="简介描述" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入简介描述（富文本摘要）"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分类" prop="category_id">
              <el-select v-model="form.category_id" placeholder="请选择分类" style="width: 100%;">
                <el-option v-for="item in categoryOptions" :key="item.id" :label="item.title" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作者" prop="author">
              <el-input v-model="form.author" placeholder="请输入作者名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="展示类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择类型" style="width: 100%;">
                <el-option label="纯文字" :value="0" />
                <el-option label="左边标题右边一张图" :value="1" />
                <el-option label="上面标题底下三张图" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="角标" prop="mark">
              <el-input v-model="form.mark" placeholder="可选，如：热门、推荐"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排序" prop="sort">
              <el-input v-model.number="form.sort" type="number" placeholder="请输入排序值"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="是否置顶" prop="isInTop">
              <el-switch v-model="form.isInTop" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否显示" prop="status">
              <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="显示" inactive-text="不显示"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="点击数" prop="click_count">
              <el-input v-model.number="form.click_count" type="number" placeholder="请输入点击数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享数" prop="share_count">
              <el-input v-model.number="form.share_count" type="number" placeholder="请输入分享数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收藏数" prop="collection_count">
              <el-input v-model.number="form.collection_count" type="number" placeholder="请输入收藏数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 封面图上传 -->
        <el-form-item label="封面图" prop="fengmian_urls">
          <el-upload 
            :action="uploadURL" 
            :headers="headerObj" 
            list-type="picture-card" 
            :limit="3"
            :file-list="fengmianFileList" 
            :on-success="handleCoverSuccess" 
            :on-remove="handleCoverRemove" 
            name="images"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">最多上传3张封面图，推荐尺寸 750x420</div>
        </el-form-item>

        <!-- 富文本编辑器 - 详细内容 -->
        <el-form-item label="详细内容" prop="content">
          <quill-editor v-model="form.content" :options="editorOption" ref="myQuillEditor"></quill-editor>
          <input id="zixun-quill-image-input" ref="quillImageInput" type="file" multiple accept="image/*" style="display:none"
            @change="handleQuillImageChange" />
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 悬浮操作按钮 -->
    <div class="floating-actions">
      <el-button type="default" class="btnBack" @click="goBack">返回</el-button>
      <el-button type="primary" class="btnAdd" @click="submitForm">{{ isEditMode ? '更新资讯' : '添加资讯' }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadURL: 'https://jxpyq666.com/common/uploads',
      form: {
        id: null,
        title: '',
        description: '',
        fengmian_urls: '',
        category_id: null,
        author: '',
        content: '',
        mark: '',
        type: 0,
        isInTop: 0,
        sort: 5,
        click_count: 1,
        share_count: 0,
        collection_count: 0,
        status: 1
      },
      formRules: {
        title: [{ required: true, message: '请输入资讯标题', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
        content: [{ required: true, message: '请输入详细内容', trigger: 'blur' }]
      },
      editorOption: {
        placeholder: '请输入详细内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ['link', 'image'],
              ['clean']
            ],
            handlers: {
              image: function (value) {
                if (value) {
                  const input = document.getElementById('zixun-quill-image-input')
                  if (input) input.click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      categoryOptions: [],
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      fengmianFileList: [],
      queryId: null
    }
  },

  computed: {
    isEditMode() {
      return !!this.queryId
    }
  },

  created() {
    const qid = this.$route && this.$route.query && this.$route.query.id
    this.queryId = qid ? Number(qid) : null
    if (this.queryId) {
      this.getDetail()
    }
    this.getCategoryList()
  },

  methods: {
    goBack() {
      this.$router.back()
    },

    // 获取分类列表
    async getCategoryList() {
      const { data: res } = await this.$http.get('admin/zc/list')
      if (res.code !== 200) {
        return this.$message.error('获取资讯分类列表失败！')
      }
      this.categoryOptions = res.result.items || res.result || []
    },

    // 获取资讯详情
    async getDetail() {
      try {
        const { data: res } = await this.$http.get('admin/z/detail', {
          params: { id: this.queryId }
        })
        if (res.code !== 200) {
          return this.$message.error('获取资讯详情失败！')
        }
        const detail = res.result || {}
        this.form = { ...this.form, ...detail }
        // 设置封面初始预览
        if (detail.fengmian_urls) {
          const urls = this.parseFengmianUrls(detail.fengmian_urls)
          this.fengmianFileList = urls.map((url, idx) => ({ name: `封面${idx + 1}`, url }))
        } else {
          this.fengmianFileList = []
        }
        this.$message.success('获取资讯详情成功！')
      } catch (e) {
        console.log(e)
        this.$message.error('获取资讯详情异常！')
      }
    },

    // 解析封面图片数组
    parseFengmianUrls(urlsStr) {
      if (!urlsStr) return []
      try {
        const parsed = JSON.parse(urlsStr)
        return Array.isArray(parsed) ? parsed : [urlsStr]
      } catch {
        return urlsStr.split(',').filter(u => u.trim())
      }
    },

    // 封面上传成功
    handleCoverSuccess(response, file, fileList) {
      if (response && response.code === 200) {
        const url = response.result && (response.result.show || response.result.url || response.result.path)
        if (url) {
          const urls = this.fengmianFileList.map(f => f.url).filter(Boolean)
          urls.push(url)
          this.form.fengmian_urls = JSON.stringify(urls)
          this.fengmianFileList = urls.map((u, idx) => ({ name: `封面${idx + 1}`, url: u }))
        }
      } else {
        this.$message.error('封面上传失败！')
      }
    },

    // 封面移除
    handleCoverRemove(file, fileList) {
      const urls = fileList.map(f => f.url || (f.response && f.response.result && (f.response.result.show || f.response.result.url))).filter(Boolean)
      this.form.fengmian_urls = urls.length > 0 ? JSON.stringify(urls) : ''
      this.fengmianFileList = urls.map((u, idx) => ({ name: `封面${idx + 1}`, url: u }))
    },

    // 富文本编辑器图片上传
    async handleQuillImageChange(e) {
      const files = Array.from(e.target.files || [])
      if (!files.length) return
      let successCount = 0
      for (const file of files) {
        try {
          const url = await this.uploadImageToServer(file)
          this.insertImageToEditor(url)
          successCount++
        } catch (err) {
          console.log(err)
        }
      }
      if (successCount > 0) {
        this.$message.success(`已上传并插入${successCount}张图片！`)
      } else {
        this.$message.error('图片上传失败！')
      }
      e.target.value = ''
    },

    async uploadImageToServer(file) {
      const fd = new FormData()
      fd.append('images', file)
      const token = window.sessionStorage.getItem('token')
      const resp = await fetch(this.uploadURL, {
        method: 'POST',
        headers: {
          Authorization: token || ''
        },
        body: fd
      })
      const data = await resp.json()
      if (!data || data.code !== 200) {
        throw new Error('upload failed')
      }
      return data.result && (data.result.show || data.result.url || data.result.path)
    },

    insertImageToEditor(imageUrl) {
      if (!imageUrl) throw new Error('empty image url')
      try {
        const quill = this.$refs.myQuillEditor.quill
        const selection = quill.getSelection()
        const index = selection ? selection.index : quill.getLength()
        quill.insertEmbed(index, 'image', imageUrl)
        quill.setSelection(index + 1)
        this.form.content = quill.root.innerHTML
      } catch (e) {
        console.log(e)
        this.$message.error('图片插入失败！')
      }
    },

    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        try {
          let res
          if (this.isEditMode) {
            ({ data: res } = await this.$http.post('admin/z/edit', this.form))
            if (res.code !== 200) return this.$message.error('更新资讯失败！')
            this.$message.success('更新资讯成功！')
          } else {
            ({ data: res } = await this.$http.post('admin/z/add', this.form))
            if (res.code !== 200) return this.$message.error('添加资讯失败！')
            this.$message.success('添加资讯成功！')
          }
          this.$router.push('/zixunList')
        } catch (e) {
          console.log(e)
          this.$message.error(this.isEditMode ? '更新资讯异常！' : '添加资讯异常！')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.btnAdd {
  margin-top: 20px;
}

.floating-actions {
  position: fixed;
  right: 32px;
  bottom: 32px;
  display: flex;
  gap: 12px;
  z-index: 1000;
}

.btnBack {
  background: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.btnBack:hover {
  color: #409eff;
  border-color: #c6e2ff;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style>
